export default __webpack_public_path__ + "scene4_2_icon213fb4.png";